module.exports = __webpack_public_path__ + "static/media/desktop_locationpartners_bb.aa2d18bf.png";